"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTipContentContainerProperty = exports.tipContentContainerPropertyDefinition = void 0;
exports.tipContentContainerPropertyDefinition = {
    view: { label: 'Tip Container' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['tip-content'],
        },
    ],
    type: 'ordered-container',
    multiple: false,
    name: 'tip-content-container',
};
const isTipContentContainerProperty = (prop) => {
    return prop.name === exports.tipContentContainerPropertyDefinition.name;
};
exports.isTipContentContainerProperty = isTipContentContainerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwLWNvbnRlbnQtY29udGFpbmVyLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdGlwLWNvbnRlbnQtY29udGFpbmVyLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGVBQWUsRUFBRTtJQUNoQyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFLENBQUMsYUFBYSxDQUFDO1NBQzFCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHVCQUF1QjtDQUNFLENBQUE7QUFJMUIsTUFBTSw2QkFBNkIsR0FBRyxDQUFDLElBQWtCLEVBQXVDLEVBQUU7SUFDdkcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDZDQUFxQyxDQUFDLElBQUksQ0FBQTtBQUNqRSxDQUFDLENBQUE7QUFGWSxRQUFBLDZCQUE2QixpQ0FFekMifQ==